module.exports = __webpack_public_path__ + "static/img/foot-logo.acb756c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/foot-logo.png
// module id = nKBI
// module chunks = 33